import createReactComponent from '../createReactComponent';
export default createReactComponent('wifi-low', 'WifiLow', [["path",{"d":"M16 16.157a5.657 5.657 0 0 0-8 0m4 3.093v-.5","key":"svg-0"}]]);